import React from 'react';
import { useCustomerStatus } from 'src/core/state/user';
import { useSetResolved } from 'src/core/engine/router/index';
import { CustomisationLogin } from 'src/components/CustomisationPage/CustomisationLogin';
import { usePathname } from 'src/hooks/router-hooks';
import { useDeps } from 'src/hooks/useDeps';
import { AppendState, EntryKind } from 'src/components/CustomisationPage/feature/customisation.actions';
import { shallowEqual, useSelector } from 'react-redux';

import classes from './LayoutCustomisation.scss';
import { PageTitle } from './PageTitle';

type Props = {
    login: React.ReactNode;
    side: React.ReactNode;
    main: React.ReactNode;
};

export const LayoutCustomisation: React.FC<Props> = React.memo((props) => {
    useSetResolved();
    const { isSignedIn } = useCustomerStatus();
    const pathname = usePathname();
    const { paths } = useDeps();
    const kind = useSelector(kindSelector, shallowEqual);
    const showLogin = !isSignedIn && pathname.indexOf(paths.customisation.configure) !== 0;
    return (
        <article className={classes.root}>
            <aside className={classes.side}>{props.side}</aside>
            <div className={classes.main}>
                {showLogin && (
                    <section className={classes.login}>
                        <CustomisationLogin />
                    </section>
                )}
                <div className={classes.title}>
                    <PageTitle title={(kind === EntryKind.New ? 'Add' : 'Edit') + ' your logo'} />
                </div>
                <section>{props.main}</section>
            </div>
        </article>
    );
});

function kindSelector(s: AppendState) {
    return s.customisation.entry_kind;
}
